export default __webpack_public_path__ + "static/media/nr.01ea0939.svg";